import React from "react";

import {startCase} from "lodash-es";

import * as constants from "@client/constants";
import * as typography from "@client/shared/typography";

import {ManagerTable} from "@client/components/ManagerTable";
import {ManagerLayout} from "@client/site/ManagerLayout";
import {reverse, server} from "@reactivated";

import {MetricStatus} from "./ClientDashboard";
import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.MealPlanList) => {
    const columns = [{name: "Name", accessor: "name"}].concat(
        constants.CORE_METRICS.map(([metric]) => ({
            name: startCase(metric),
            accessor: metric,
        })),
    );

    const values = props.meal_plans.map((mealPlan) =>
        constants.CORE_METRICS.reduce<Record<string, React.ReactNode>>(
            (accumulator, [metric, , , unit]) => ({
                ...accumulator,
                [metric]: (
                    <MetricStatus
                        noStatus={true}
                        status="na"
                        total={mealPlan[metric]}
                        target={null}
                        unit={unit}
                    />
                ),
            }),
            {
                name: mealPlan.name,
                link: reverse("meal_plan_detail", {meal_plan_id: mealPlan.id}),
            },
        ),
    );

    return (
        <ManagerLayout title="Meal Plans" currentClientManagerId={null}>
            <div className="flex flex-col space-y-[15px]">
                <ClientNavigation>
                    <typography.Header>Meal Plans</typography.Header>

                    <typography.ButtonGroup>
                        <typography.Button href={reverse("meal_plans_create")}>
                            Create meal plan
                        </typography.Button>
                    </typography.ButtonGroup>
                </ClientNavigation>

                <ManagerTable columns={columns} values={values} />
            </div>
        </ManagerLayout>
    );
};
